import {
  InstagramRadioButtonType,
  generateRadioButtonStageDefs,
} from './instagramRadioButtonUtils'
import { commentFilterUrl } from './instagramUrls'
import { InstagramSettingKey } from '../../recommendations/recommendationSettingsKeys'
import { InstagramRecommendationKey } from '../../utils/enums'
import {
  defaultCantUndoFn,
  defaultIsDisabledFn,
  defaultIsDisabledReasonFn,
  getCurrentValueFnFromKey,
  getIsFulfilledFnFromKey,
} from '../recommendationCardDisplayUtils'

const INITIAL_VALUES_SAVE_KEY = InstagramSettingKey.ALLOW_COMMENTS_FROM
const SECTION_LABEL = 'Allow comments from'

enum CommentPrivacyLevel {
  EVERYONE = 'Everyone',
  PEOPLE_YOU_FOLLOW = 'People You Follow',
  YOUR_FOLLOWERS = 'Your Followers',
  PEOPLE_YOU_FOLLOW_AND_YOUR_FOLLOWERS = 'People You Follow and Your Followers',
  UNKNOWN = 'Unknown',
}

const TARGET_COMMENT_PRIVACY_LEVEL =
  CommentPrivacyLevel.PEOPLE_YOU_FOLLOW_AND_YOUR_FOLLOWERS

function shouldUpdate(currentValue: CommentPrivacyLevel): boolean {
  // Don't update if is PEOPLE_YOU_FOLLOW or YOUR_FOLLOWERS
  return (
    CommentPrivacyLevel.EVERYONE === currentValue ||
    CommentPrivacyLevel.UNKNOWN === currentValue
  )
}

const getCurrentValueFn = (key) =>
  getCurrentValueFnFromKey(key, (value) => value)
const getIsFulfilledFn = (key) =>
  getIsFulfilledFnFromKey(key, (value) => !shouldUpdate(value))
const getCantUndoFn = () => defaultCantUndoFn
const getIsDisabledFn = () => defaultIsDisabledFn
const getIsDisabledReasonFn = () => defaultIsDisabledReasonFn

enum StageKey {
  GATHER_WHO_CAN_COMMENT = 'GATHER_WHO_CAN_COMMENT',
  UPDATE_WHO_CAN_COMMENT = 'UPDATE_WHO_CAN_COMMENT',
  UNDO_WHO_CAN_COMMENT = 'UNDO_WHO_CAN_COMMENT',
}

const { gatherStageDefs, updateStageDefs, undoStageDefs } =
  generateRadioButtonStageDefs(
    InstagramRecommendationKey.INSTAGRAM_WHO_CAN_COMMENT,
    [INITIAL_VALUES_SAVE_KEY],
    () => SECTION_LABEL,
    () => TARGET_COMMENT_PRIVACY_LEVEL,
    shouldUpdate,
    StageKey.GATHER_WHO_CAN_COMMENT,
    StageKey.UPDATE_WHO_CAN_COMMENT,
    StageKey.UNDO_WHO_CAN_COMMENT,
    commentFilterUrl,
    InstagramRadioButtonType.Input,
  )

export {
  getCantUndoFn,
  getCurrentValueFn,
  getIsDisabledFn,
  getIsDisabledReasonFn,
  getIsFulfilledFn,
  gatherStageDefs,
  updateStageDefs,
  undoStageDefs,
}
